import { render, staticRenderFns } from "./IdeaCoachForm.vue?vue&type=template&id=9e947c5a&scoped=true&"
import script from "./IdeaCoachForm.vue?vue&type=script&lang=js&"
export * from "./IdeaCoachForm.vue?vue&type=script&lang=js&"
import style0 from "./IdeaCoachForm.vue?vue&type=style&index=0&id=9e947c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e947c5a",
  null
  
)

export default component.exports